export const BANNER_POSITION = {
  TEST: 'TEST',
  TEST_DETAIL: 'TEST_DETAIL',
  SUGAR_MALL_TOP: '슈가몰 홈 배너',
  HOME_BOTTOM: '홈 하단 배너',
  HOME_MIDDLE: '홈 중간 배너',
  HOME_TOP_BENEFIT: '홈 상단 혜택 슬라이드',
  HOME_MAIN_BOTTOM_SHEET: '홈 바텀 시트 모달',
  BENEFIT_TOP: '혜택 배너(이벤트)',
  MY_PAGE_TOP: '마이페이지 상단 배너',
  COACH_TOP: '코치 상단 배너',
}

export const BANNER_CLICK_TYPE = {
  EXTERNAL_LINK: '외부링크 이동',
  INTERNAL_ROUTE: '단순 페이지 이동형',
  DETAIL_PAGE: '상세페이지 관리형',
}

export const BANNER_EXTERNAL_ROUTE_JSON_EXAMPLE = `{
  "linkUrl": "https://smartstore.naver.com/sugarcoach_/products/11368152396",
  "routeParams": {}
}`

export const BANNER_INTERNAL_ROUTE_JSON_EXAMPLE = `{
  "routeName": "SugarMallProductDetailScreen",
  "routeParams": {"productId": 143}
}`

export const BANNER_DETAIL_PAGE_JSON_EXAMPLE = `{
  "routeName": "SugarMallCouponEventScreen",
  "routeParams": {
    "imageUrl": "https://sugarcoach-assets.s3.ap-northeast-2.amazonaws.com/images/coupon/review_event_1.png"
  }
}`
